import { logo } from "assets/icons";

export const Header = () => {
  return (
    <section className="header-section">
      <div className="header-section__content-container container">
        <img src={logo} alt="logo" />
      </div>
    </section>
  );
};
